import { HandHeart, MapPin, Phone } from "lucide-react";
import { Card } from "./ui";

/** Daftar keluhan yang dapat ditangani menurut pengelola TPKS. */
const CONDITIONS = [
  "Jantung",
  "Stroke",
  "Ginjal",
  "Liver",
  "Migrain",
  "Maag",
  "Hipotermia",
  "Ashma",
  "Asam Urat",
  "Alergi",
  "Syaraf Terjepit (HNP)",
  "Tekanan Darah Tinggi",
  "Sembelit",
  "Kolesterol",
  "Infeksi",
  "dan lain-lain",
];

/** Penjelasan metode terapi totok punggung. */
const METHOD_POINTS = [
  "Suatu metode pengobatan/terapi.",
  "Menggunakan jari-jari tangan.",
  "Dengan cara tempel, tekan dan getarkan untuk memberikan stimulasi (penotokan) pada titik atau simpul syaraf tertentu.",
  "Berpusat di area punggung, titik atau simpul tersebut terkoneksi langsung dengan keluhan penyakit atau organ yang sedang mengalami gangguan.",
  "Digunakan untuk mengurai stagnasi/timbunan di dalam dan di luar pembuluh darah yang menghambat sirkulasi darah.",
];

const LOCATIONS = [
  {
    name: "GOR Jampang Srengseng Sawah",
    address:
      "Jl. H. Nalim Rt. 001/08 No. 69A Jagakarsa, Jakarta Selatan (depan Puskesmas Srengseng Sawah).",
  },
  {
    name: "Jl. Raya Citayam",
    address: "Rt. 002/05 No. 7 Pondok Jaya, Cipayung, Depok.",
  },
];

/**
 * Panel informasi Terapi Totok Punggung Keluarga Syafi’i (TPKS).
 * Dipakai berdampingan dengan area login pada halaman beranda dan masuk.
 */
export function TotokInfoPanel({ className = "" }: { className?: string }) {
  return (
    <Card className={`totok-info ${className}`}>
      <header className="totok-info-head">
        <span className="brand-mark brand-mark-lg" aria-hidden>
          <HandHeart size={26} />
        </span>
        <h2>Terapi Totok Punggung Keluarga Syafi’i (TPKS)</h2>
        <p className="totok-info-lead">Dengan izin Allah dapat mengatasi penyakit:</p>
      </header>

      <ul className="totok-tags">
        {CONDITIONS.map((c) => (
          <li key={c} className="totok-tag">
            {c}
          </li>
        ))}
      </ul>

      <section className="totok-section">
        <h3>Terapi Totok Punggung</h3>
        <ul className="totok-points">
          {METHOD_POINTS.map((p) => (
            <li key={p}>{p}</li>
          ))}
        </ul>
      </section>

      <p className="totok-prayer">
        <strong>Bismillah</strong>
        <span>Dengan Totok Punggung Insya Allah Sehat</span>
      </p>

      <section className="totok-section">
        <h3>Lokasi Layanan</h3>
        <ul className="totok-locations">
          {LOCATIONS.map((l) => (
            <li key={l.name}>
              <MapPin size={16} aria-hidden className="totok-location-icon" />
              <div>
                <strong>{l.name}</strong>
                <span>{l.address}</span>
              </div>
            </li>
          ))}
        </ul>
      </section>

      <a className="totok-contact" href="tel:+6283131042394">
        <span className="totok-contact-icon" aria-hidden>
          <Phone size={16} />
        </span>
        <span className="totok-contact-body">
          <strong>As’ad Syafi’i</strong>
          <span>0831 3104 2394</span>
        </span>
      </a>
    </Card>
  );
}
